import { useEffect } from "react";

export const usePersistentFilters = ({
  form,
  location,
  currentPath,
  addPath,
  editPathPrefix,
  storageKey,
  inputData,
  setInputData,
  paginationModel,
  setPaginationModel,
}) => {
  useEffect(() => {
    const prevPath = sessionStorage.getItem("previousPath") || "";
    const isReturningFromAddOrEdit =
      prevPath === addPath || prevPath.includes(editPathPrefix);

    if (location.pathname === currentPath) {
      const savedFilters = localStorage.getItem(storageKey);

      if (isReturningFromAddOrEdit && savedFilters) {
        const parsed = JSON.parse(savedFilters);
        setInputData(parsed.inputData || {});
        setPaginationModel(parsed.paginationModel || { page: 1, limit: 10 });
        form.setFieldsValue(parsed.inputData || {});
      } else if (!isReturningFromAddOrEdit && !savedFilters) {
        setInputData({});
        setPaginationModel({ page: 1, limit: 10 });
        form.resetFields();
      }
    }

    sessionStorage.setItem("previousPath", location.pathname);
  }, [
    form,
    location.pathname,
    currentPath,
    addPath,
    editPathPrefix,
    storageKey,
    setInputData,
    setPaginationModel,
  ]);

  useEffect(() => {
    localStorage.setItem(
      storageKey,
      JSON.stringify({ inputData, paginationModel })
    );
  }, [inputData, paginationModel, storageKey]);
};
